webpackJsonp([35783957827783],{

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(25);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(42);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(41);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(81);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(80);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  var _props$opacity = props.opacity,
	      opacity = _props$opacity === undefined ? "" : _props$opacity,
	      src = props.src,
	      srcSet = props.srcSet,
	      _props$sizes = props.sizes,
	      sizes = _props$sizes === undefined ? "" : _props$sizes,
	      _props$title = props.title,
	      title = _props$title === undefined ? "" : _props$title,
	      _props$alt = props.alt,
	      alt = _props$alt === undefined ? "" : _props$alt,
	      _props$width = props.width,
	      width = _props$width === undefined ? "" : _props$width,
	      _props$height = props.height,
	      height = _props$height === undefined ? "" : _props$height,
	      _props$transitionDela = props.transitionDelay,
	      transitionDelay = _props$transitionDela === undefined ? "" : _props$transitionDela;
	
	  return "<img width=" + width + " height=" + height + " src=\"" + src + "\" srcset=\"" + srcSet + "\" alt=\"" + alt + "\" title=\"" + title + "\" sizes=\"" + sizes + "\" style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;objectPosition:center\"/>";
	};
	
	var Img = function Img(props) {
	  var opacity = props.opacity,
	      onLoad = props.onLoad,
	      _props$transitionDela2 = props.transitionDelay,
	      transitionDelay = _props$transitionDela2 === undefined ? "" : _props$transitionDela2,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["opacity", "onLoad", "transitionDelay"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: {
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      transitionDelay: transitionDelay,
	      opacity: opacity,
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }
	  }));
	};
	
	Img.propTypes = {
	  opacity: _propTypes2.default.number,
	  transitionDelay: _propTypes2.default.string,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        "div",
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden",
	              zIndex: 1
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement("div", {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement("div", {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        zIndex: 1,
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        "div",
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.35s"
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement("div", {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: ""
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func
	};
	
	exports.default = Image;

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(71);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(100);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _squiggle = __webpack_require__(40);
	
	var _squiggle2 = _interopRequireDefault(_squiggle);
	
	var _styleModule = __webpack_require__(294);
	
	var _styleModule2 = _interopRequireDefault(_styleModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Home = function (_React$Component) {
	  _inherits(Home, _React$Component);
	
	  function Home() {
	    _classCallCheck(this, Home);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Home.prototype.render = function render() {
	    var h1_style = {
	      fontSize: Math.min(Math.max(typeof window !== 'undefined' ? window.innerWidth / 100 * 8 : 1200 / 100 * 8), 86) + 'px'
	    };
	
	    var dot = _react2.default.createElement(
	      'div',
	      { className: _styleModule2.default.dot },
	      _react2.default.createElement(
	        'svg',
	        { viewBox: '0 0 10 10', fill: 'currentColor' },
	        _react2.default.createElement('circle', { cx: '5', cy: '5', r: '5' })
	      )
	    );
	
	    var large_squiggle_size = 252;
	    var small_squiggle_size = 72;
	
	    var h1 = _react2.default.createElement(
	      'h1',
	      { className: _styleModule2.default.heading, style: h1_style },
	      'Betsy ',
	      _react2.default.createElement(
	        'span',
	        { className: _styleModule2.default.ampersand },
	        '&'
	      ),
	      ' Thomas',
	      ' ',
	      _react2.default.createElement(
	        'span',
	        {
	          style: {
	            position: 'relative',
	            left: '8px',
	            display: 'inline-block'
	          } },
	        'got married.'
	      )
	    );
	
	    if (this.props.hostname && this.props.hostname === 'thomasandbetsy.com' || this.props.hostname === 'www.thomasandbetsy.com') {
	      h1 = _react2.default.createElement(
	        'h1',
	        { className: _styleModule2.default.heading, style: h1_style },
	        'Thomas ',
	        _react2.default.createElement(
	          'span',
	          { className: _styleModule2.default.ampersand },
	          '&'
	        ),
	        ' Betsy',
	        ' ',
	        _react2.default.createElement(
	          'span',
	          {
	            style: {
	              position: 'relative',
	              left: '8px',
	              display: 'inline-block'
	            } },
	          'got married.'
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: _styleModule2.default.outerContainer },
	      _react2.default.createElement(
	        'div',
	        {
	          className: _styleModule2.default.container,
	          'data-loaded': typeof window !== 'undefined' && window.innerWidth > 0 },
	        _react2.default.createElement(
	          'div',
	          { className: _styleModule2.default.headerContainer },
	          h1
	        ),
	        _react2.default.createElement(_squiggle2.default, { height: large_squiggle_size }),
	        _react2.default.createElement(
	          'div',
	          { className: _styleModule2.default.blurb },
	          _react2.default.createElement(
	            'div',
	            null,
	            'Saturday, August 12, 2017'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _styleModule2.default.detail },
	            'Six o\u2019clock in the evening'
	          ),
	          _react2.default.createElement(_squiggle2.default, { height: small_squiggle_size }),
	          _react2.default.createElement(
	            'a',
	            { href: 'http://bkwinery.com/', className: _styleModule2.default.information_section },
	            _react2.default.createElement(
	              'div',
	              null,
	              'Brooklyn Winery'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _styleModule2.default.detail },
	              'Brooklyn, New York'
	            )
	          ),
	          _react2.default.createElement(_squiggle2.default, { height: small_squiggle_size }),
	          _react2.default.createElement(
	            'div',
	            { className: _styleModule2.default.information_section },
	            _react2.default.createElement(
	              'div',
	              { className: _styleModule2.default.accommodations_detail },
	              'Accommodations'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _styleModule2.default.hotel },
	              'Out-of-town guests can reserve a room at the',
	              ' ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://aws.passkey.com/event/48971128/owner/13490/home' },
	                'Marriott Brooklyn Bridge'
	              ),
	              '. Shuttles to and from the wedding ceremony will be provided.'
	            )
	          ),
	          _react2.default.createElement(_squiggle2.default, { height: small_squiggle_size }),
	          _react2.default.createElement(
	            'div',
	            { className: _styleModule2.default.information_section },
	            _react2.default.createElement(
	              'div',
	              { className: _styleModule2.default.accommodations_detail },
	              'Map'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _styleModule2.default.map },
	              'For those staying at the hotel or nearby, we made a',
	              ' ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/map' },
	                'map of the neighborhood'
	              ),
	              '.'
	            )
	          ),
	          _react2.default.createElement(_squiggle2.default, { height: small_squiggle_size }),
	          _react2.default.createElement(
	            'div',
	            { className: _styleModule2.default.information_section },
	            _react2.default.createElement(
	              'div',
	              { className: _styleModule2.default.accommodations_detail },
	              'Parking'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _styleModule2.default.hotel },
	              'We recommend two lots a short walk\u2019s distance from the winery: 568\xA0Union Avenue and 544\xA0Union Avenue.'
	            )
	          ),
	          _react2.default.createElement(_squiggle2.default, { height: small_squiggle_size }),
	          _react2.default.createElement(
	            'div',
	            { className: _styleModule2.default.information_section },
	            _react2.default.createElement(
	              'div',
	              { className: _styleModule2.default.accommodations_detail },
	              'Registry'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _styleModule2.default.hotel },
	              'We\u2019ve set up a',
	              ' ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.blueprintregistry.com/registry/betsyandthomas' },
	                'gift registry'
	              ),
	              '.'
	            )
	          ),
	          _react2.default.createElement(_squiggle2.default, { height: large_squiggle_size }),
	          _react2.default.createElement(_gatsbyImage2.default, {
	            outerWrapperClassName: _styleModule2.default.imageWrapper,
	            className: _styleModule2.default.image,
	            sizes: this.props.headerImage.sizes
	          })
	        )
	      )
	    );
	  };
	
	  return Home;
	}(_react2.default.Component);
	
	exports.default = Home;
	module.exports = exports['default'];

/***/ }),

/***/ 294:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"outerContainer":"src-components-home----style-module---outerContainer---WYPzA","heading":"src-components-home----style-module---heading---2vbgz","container":"src-components-home----style-module---container---2VDFV","headerContainer":"src-components-home----style-module---headerContainer---tRGRU","ampersand":"src-components-home----style-module---ampersand---1cCph","blurb":"src-components-home----style-module---blurb---2brNB","information_section":"src-components-home----style-module---information_section---vdl2G","detail":"src-components-home----style-module---detail---3EZ2Z","accommodations_detail":"src-components-home----style-module---accommodations_detail---2-tBf","dot":"src-components-home----style-module---dot---2qke2","hotel":"src-components-home----style-module---hotel---3yTFD","map":"src-components-home----style-module---map---1A9zH","imageWrapper":"src-components-home----style-module---imageWrapper---3yIHb","image":"src-components-home----style-module---image---27y_Z"};

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styleModule = __webpack_require__(51);
	
	var _styleModule2 = _interopRequireDefault(_styleModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Squiggle = function (_React$Component) {
	  _inherits(Squiggle, _React$Component);
	
	  function Squiggle() {
	    _classCallCheck(this, Squiggle);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Squiggle.prototype.render = function render() {
	    var origin = {
	      //origin of axes
	      x: 0,
	      y: 0
	    };
	    var amplitude = 8; // wave amplitude
	    var rarity = 1; // point spacing
	    var freq = 0.175; // angular frequency
	    var phase = 20; // phase angle
	    var stroke_width = 1.5;
	    var svg_height = this.props.height || 1000;
	    var stroke_color = this.props.strokeColor || 'white';
	
	    var lines = [];
	
	    for (var i = 0; i < svg_height; i++) {
	      lines.push(_react2.default.createElement('line', {
	        y1: (i - 1) * rarity + origin.x,
	        x1: Math.sin(freq * (i - 1 + phase)) * amplitude + amplitude + stroke_width / 2,
	        y2: i * rarity + origin.x,
	        x2: Math.sin(freq * (i + phase)) * amplitude + amplitude + stroke_width / 2,
	        key: i
	      }));
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: _styleModule2.default.squiggle },
	      _react2.default.createElement(
	        'svg',
	        {
	          width: amplitude * 2 + stroke_width * 2,
	          height: svg_height,
	          strokeWidth: stroke_width,
	          stroke: stroke_color },
	        lines
	      )
	    );
	  };
	
	  return Squiggle;
	}(_react2.default.Component);
	
	exports.default = Squiggle;
	module.exports = exports['default'];

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"squiggle":"src-components-squiggle----style-module---squiggle---2QPWR"};

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(71);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _home = __webpack_require__(201);
	
	var _home2 = _interopRequireDefault(_home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(_home2.default, { headerImage: data.headerImage });
	};
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-8121760c03e3ab8c6cb5.js